import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CONSENT_KEY = 'fv_analytics_consent';

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) setVisible(true);
  }, []);

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
    if (window.__posthog) {
      window.__posthog.opt_in_capturing();
      window.__posthog.set_config({ persistence: 'localStorage+cookie' });
    }
  };

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setVisible(false);
    window.__posthog?.opt_out_capturing();
  };

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 2000,
      background: 'var(--card, #111a2e)',
      borderTop: '1px solid var(--border, #1e2d44)',
      padding: '12px clamp(14px, 3vw, 32px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 12,
    }}>
      <p style={{
        margin: 0, flex: '1 1 260px',
        fontFamily: "var(--font-body, 'Figtree', sans-serif)",
        fontSize: 13, color: '#8892a5', lineHeight: 1.5,
      }}>
        We use privacy-friendly analytics to improve FathomVoyage. No ads, no tracking for marketing.{' '}
        <button
          onClick={() => navigate('/privacy')}
          style={{
            background: 'none', border: 'none', padding: 0,
            color: '#e9a020', fontSize: 13, cursor: 'pointer',
            fontFamily: "var(--font-body, 'Figtree', sans-serif)",
            textDecoration: 'underline',
          }}
        >
          Learn more
        </button>
      </p>

      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button
          onClick={decline}
          style={{
            padding: '8px 16px', minHeight: 36,
            background: 'transparent',
            border: '1px solid #1e2d44',
            borderRadius: 6,
            color: '#8892a5',
            fontFamily: "var(--font-body, 'Figtree', sans-serif)",
            fontSize: 13, cursor: 'pointer',
            transition: 'border-color 0.15s, color 0.15s',
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = '#2a3f5f'; e.currentTarget.style.color = '#c4ccd8'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = '#1e2d44'; e.currentTarget.style.color = '#8892a5'; }}
        >
          Decline
        </button>
        <button
          onClick={accept}
          style={{
            padding: '8px 20px', minHeight: 36,
            background: '#e9a020',
            border: 'none',
            borderRadius: 6,
            color: '#0a1628',
            fontFamily: "var(--font-display, 'Fraunces', serif)",
            fontSize: 13, fontWeight: 700, cursor: 'pointer',
            transition: 'opacity 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.opacity = '0.88'}
          onMouseLeave={e => e.currentTarget.style.opacity = '1'}
        >
          Accept
        </button>
      </div>
    </div>
  );
}
